import ReactDOM from "react-dom";
import "react-alice-carousel/lib/alice-carousel.css";
import App from "./App";
import CryptoContext from "./CryptoContext";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <CryptoContext>
    <App />
  </CryptoContext>,
  rootElement
);
